import { type QueryClient, queryOptions } from '@tanstack/react-query';

import { request } from '~/services/common';

import type { LensResponse } from '~/types/leLens';

import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

export function lensLiveStateQuery(client: QueryClient, id: string) {
  return queryOptions({
    queryKey: ['lens-live-state', id],
    retry: false,
    queryFn: async ({ signal }) => {
      const live = client.getQueryData<LensResponse>(['lens-live-state', id]);
      const detail = client.getQueryData<LensResponse>(['reporting', 'le-lens', 'detail', id]);
      const previous = detail && (!live || detail.lens.version >= live.lens.version) ? detail : live;
      const response = (await request(
        resolveReportingLeLensUrl(
          `/api/reporting/le-lenses/${id}${previous ? `?knownVersion=${previous.lens.version}` : ''}`,
        ),
        { signal },
      )) as LensResponse | { version: number };
      return 'lens' in response ? response : previous!;
    },
  });
}
